<template>
  <div class="multi-angle-generation-container">
    <!-- 顶部 header -->
    <header>
      <div class="header-content">
        <div class="logo-section">
          <img v-if="theme"
            src="https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/System_Default/logo.png" alt="待加载">
          <img v-else src="https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/System_Default/dark_logo.png"
            alt="待加载">
        </div>

        <!-- GPU 实时监控 -->
        <gpu-monitor />

        <div class="header-spacer"></div>
        <div class="header-actions">
          <!-- 返回主页按钮 -->
          <div class="home-btn" @click="gohome">
            <span class="iconfont"></span>
            <span>返回主页</span>
          </div>
          <!-- 生图记录按钮 -->
          <div class="header-btn" @click="handleGoToImageLog">
            <span class="iconfont">&#xe640;</span>
            <span>生图记录</span>
          </div>
          <!-- 支持与反馈按钮 -->
          <div class="header-btn" @click="handleOpenFeedback">
            <span class="iconfont">&#xe681;</span>
            <span>支持与反馈</span>
          </div>
          <!-- 用户头像 -->
          <div class="user-avatar">
            <img :src="avatar" alt="待加载">
          </div>
        </div>
      </div>
    </header>

    <!-- 内容区域 -->
    <div class="multi-angle-page-wrapper">
    <!-- 左侧精简导航栏 -->
    <div class="slim-sidebar">
      <!-- 中间功能按钮区域 -->
      <div class="sidebar-middle">
        <div class="nav-item" @click="handlePromptClick" title="提示词">
          <svg class="nav-icon" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
            <path d="M661.653927 850.681606l-598.429465 0L63.224462 166.398798l598.429465 0L661.653927 850.681606zM605.57777 794.633079 605.57777 222.461651 119.313921 222.461651l0 572.172451L605.57777 794.634102" fill="currentColor"></path>
            <path d="M240.774227 366.237195c-15.442714 0-28.009937-12.568247-28.009937-28.051893 0-15.456017 12.567223-28.024264 28.009937-28.024264l252.366751 0c15.496949 0 28.052916 12.568247 28.052916 28.024264 0 15.483646-12.555967 28.051893-28.052916 28.051893L240.774227 366.237195" fill="currentColor"></path>
            <path d="M240.774227 528.002462c-15.442714 0-28.009937-12.56927-28.009937-28.052916 0-15.497972 12.567223-28.05087 28.009937-28.05087l252.366751 0c15.496949 0 28.052916 12.552897 28.052916 28.05087 0 15.482623-12.555967 28.052916-28.052916 28.052916L240.774227 528.002462" fill="currentColor"></path>
            <path d="M240.774227 689.73703c-15.442714 0-28.009937-12.539594-28.009937-28.010961 0-15.495926 12.567223-28.063149 28.009937-28.063149l252.366751 0c15.496949 0 28.052916 12.567223 28.052916 28.063149 0 15.471366-12.555967 28.010961-28.052916 28.010961L240.774227 689.73703" fill="currentColor"></path>
            <path d="M848.279395 867.327728 717.454814 705.59009l0-539.231201 242.974847 0 0 539.231201L848.279395 867.327728zM844.829829 773.906012l59.499116-85.865623L904.328945 222.461651 773.504364 222.461651l0 463.249693L844.829829 773.906012" fill="currentColor"></path>
            <path d="M754.831073 348.274078 754.831073 292.171316 923.055448 292.171316 923.055448 348.274078 754.831073 348.274078Z" fill="currentColor"></path>
          </svg>
          <span class="nav-label">提示词</span>
        </div>
        <div class="nav-item" @click="handleInspirationClick" title="灵感">
          <span class="iconfont">&#xe600;</span>
          <span class="nav-label">灵感</span>
        </div>
      </div>

      <!-- 底部功能按钮区域 -->
      <div class="sidebar-bottom">
        <div class="nav-item" @click="handleShortcutClick" title="快捷键">
          <span class="iconfont">&#xe623;</span>
        </div>
        <div class="nav-item" @click="toggleTheme" title="深色模式">
          <span class="iconfont">{{ theme ? '&#xe61c;' : '&#xe61d;' }}</span>
        </div>
      </div>
    </div>

    <!-- 右侧主内容区域 -->
    <div class="right_menu_assistant">
      <!-- 对话历史区域 -->
      <div class="chat-container" ref="chatContainer">
        <div class="chat-history" v-if="chatHistory.length > 0">
          <div v-for="(message, index) in chatHistory" :key="index"
               :class="['message-item', message.role === 'user' ? 'user-message' : 'ai-message']">
            <!-- 用户消息 -->
            <div v-if="message.role === 'user'" class="message-wrapper">
              <!-- 如果用户上传了图片，在左侧显示缩略图 -->
              <div v-if="message.images && message.images.length > 0" class="message-thumbnails">
                <div v-for="(img, imgIndex) in message.images" :key="imgIndex" class="image-thumbnail">
                  <img :src="img" alt="图片缩略图" class="thumbnail-img">
                </div>
              </div>
              <div class="message-content">
                <div class="message-text">{{ message.content }}</div>
              </div>
              <div class="message-avatar">
                <img :src="avatar" alt="用户">
              </div>
            </div>

            <!-- AI 消息 -->
            <div v-if="message.role === 'assistant'" class="message-wrapper">
              <div class="message-avatar ai-avatar">
                <span class="iconfont">&#xe6a5;</span>
              </div>
              <div class="message-content">
                <div class="message-text" :class="{ error: message.isError }" v-if="message.content">{{ message.content }}</div>
                <!-- 如果 AI 返回了图片结果 -->
                <div v-if="message.resultImages && message.resultImages.length > 0" class="message-images">
                  <div v-for="(img, imgIndex) in message.resultImages" :key="imgIndex" class="result-image-item" @click="showImagePreview(img)">
                    <img :src="img" alt="生成结果" class="result-img">
                  </div>
                </div>
                <!-- 生成中的占位框（当没有结果图片且不是错误状态时显示） -->
                <div v-else-if="!message.isError && !message.resultImages" class="message-images">
                  <div v-for="n in 5" :key="n" class="result-image-item placeholder-item">
                    <div class="placeholder-content">
                      <span class="placeholder-icon">&#xe6a5;</span>
                    </div>
                  </div>
                </div>
                <!-- 失败气泡的按钮组（仅显示重新生成） -->
                <div v-if="message.isError" class="message-actions">
                  <button class="action-btn regenerate-btn" @click="handleRegenerate(index)">
                    重新生成
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 空状态提示 -->
        <div v-else class="empty-state">
          <div class="empty-icon">📐</div>
          <h3>多角度生成</h3>
          <p>上传产品图片，AI将为你生成多角度的产品展示图</p>
        </div>

        <!-- AI 正在输入提示 -->
        <div v-if="aiTyping" class="typing-indicator">
          <div class="typing-wrapper">
            <div class="typing-avatar">
              <span class="iconfont">&#xe6a5;</span>
            </div>
            <div class="typing-content">
              <div class="typing-dots" v-if="!currentNodeName">
                <span></span>
                <span></span>
                <span></span>
              </div>
              <div v-if="currentNodeName" class="node-executing">
                <span class="node-name">{{ currentNodeName }}</span>
              </div>
            </div>
          </div>
          <!-- 5个生成中的预留框 -->
          <div class="generating-placeholder-container">
            <div v-for="n in 5" :key="n" class="generating-placeholder-item">
              <div class="placeholder-animation">
                <video ref="generatingVideos"
                  src="https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/system_start_demo/Delicate%20Moods.mp4"
                  autoplay loop muted playsinline="true"></video>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>

    <!-- 底部输入导航栏 -->
    <NaviGation_MultiAngle
      @chatUpdate="handleChatUpdate"
      @aiTyping="handleAiTyping"
      @progressUpdate="handleProgressUpdate"
      @nodeUpdate="handleNodeUpdate"
      @scrollToBottom="scrollToBottom"
      :initialChatHistory="chatHistory"
    />

    <!-- 支持与反馈弹窗 -->
    <discussion-board
      class="discussion-board"
      :boardvisible="boardvisible"
      :disscussType="disscussType"
      @update:boardvisible="boardvisible = $event"
    />

    <!-- 图片预览弹窗 -->
    <div v-if="imagePreviewVisible" class="image-preview-modal" @click="closeImagePreview">
      <div class="image-preview-content" @click.stop>
        <img :src="previewImageUrl" alt="预览图片" class="preview-image">
        <span class="close-btn" @click="closeImagePreview">&times;</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import localStorageUtils from '@/utils/setLocalStorage'
import { Message } from 'element-ui'
import NaviGation_MultiAngle from '@/components/NaviGation_MultiAngle.vue'

export default {
  name: 'MultiAngleGeneration',
  components: {
    NaviGation_MultiAngle
  },
  computed: {
    ...mapGetters(['avatar'])
  },
  data() {
    return {
      theme: true, // 主题模式
      chatHistory: [], // 对话历史
      aiTyping: false, // AI 是否正在输入
      currentProgress: '', // 当前进度
      boardvisible: false, // 支持与反馈弹窗显示状态
      disscussType: 'multi_angle_generation', // 讨论区类型
      currentNodeName: '', // 当前执行的节点名称
      imagePreviewVisible: false, // 图片预览弹窗显示状态
      previewImageUrl: '' // 预览图片URL
    }
  },
  created() {
    // 加载主题设置
    const savedTheme = localStorageUtils.getItem('theme')
    if (savedTheme !== null) {
      this.theme = savedTheme
    }
    // 加载对话历史
    this.loadChatHistory()
  },
  mounted() {
    // 滚动到底部
    this.$nextTick(() => {
      if (this.chatHistory.length > 0) {
        this.scrollToBottom()
      }
    })
  },
  methods: {
    // 返回主页
    gohome() {
      this.$router.push({ path: '/' })
    },
    // 提示词功能
    handlePromptClick() {
      // 跳转到提示词优化页面
      this.$router.push({ path: '/index/morejoyassistant_LLM' })
    },
    // 灵感功能（占位）
    handleInspirationClick() {
      Message.warning('o(*￣▽￣*)ブ开发者正在开发中,敬请期待😋!')
    },
    // 快捷键功能（占位）
    handleShortcutClick() {
      Message.info('快捷键说明：\nCtrl + Enter: 发送消息')
    },
    // 切换主题
    toggleTheme() {
      this.theme = !this.theme
      localStorageUtils.setItem('theme', this.theme)
      Message.success(this.theme ? '已切换到浅色模式' : '已切换到深色模式')
    },
    // 跳转到生图记录
    handleGoToImageLog() {
      const targetPath = '/userimagelog'
      if (this.$router.history.current.fullPath !== targetPath) {
        this.$router.push({ path: targetPath })
      }
    },
    // 打开支持与反馈
    handleOpenFeedback() {
      this.boardvisible = true
    },
    // 处理对话更新
    handleChatUpdate(history) {
      this.chatHistory = history
      this.saveChatHistory()
      this.$nextTick(() => {
        this.scrollToBottom()
      })
    },
    // 处理 AI 输入状态
    handleAiTyping(isTyping) {
      this.aiTyping = isTyping
      if (isTyping) {
        this.currentProgress = '' // 重置进度
        this.$nextTick(() => {
          this.scrollToBottom()
          // 同步视频播放
          this.syncVideoPlayback()
        })
      }
    },
    // 同步视频播放
    syncVideoPlayback() {
      this.$nextTick(() => {
        const videos = this.$refs.generatingVideos
        if (videos && videos.length > 0) {
          // 获取第一个视频作为基准
          const firstVideo = videos[0]
          // 确保所有视频从同一时间点开始
          videos.forEach(video => {
            video.currentTime = 0
            video.play().catch(() => {
              // 忽略自动播放被阻止的错误
            })
          })
          // 监听第一个视频的播放时间，同步其他视频
          firstVideo.addEventListener('timeupdate', () => {
            videos.forEach((video, index) => {
              if (index > 0 && Math.abs(video.currentTime - firstVideo.currentTime) > 0.1) {
                video.currentTime = firstVideo.currentTime
              }
            })
          })
        }
      })
    },
    // 处理进度更新
    handleProgressUpdate(progress) {
      this.currentProgress = progress
      this.$nextTick(() => {
        this.scrollToBottom()
      })
    },
    // 处理节点更新
    handleNodeUpdate(nodeName) {
      this.currentNodeName = nodeName
      this.$nextTick(() => {
        this.scrollToBottom()
      })
    },
    // 滚动到底部
    scrollToBottom() {
      const container = this.$refs.chatContainer
      if (container) {
        container.scrollTop = container.scrollHeight
      }
    },
    // 加载对话历史
    loadChatHistory() {
      const userInfo = this.$store.state.morejoy_assistant?.userInfo
      if (!userInfo || !userInfo.userId) {
        // 用户未登录，跳过加载
        return
      }
      const storageKey = `multi_angle_chat_history_${userInfo.userId}`
      const savedHistory = localStorage.getItem(storageKey)
      if (savedHistory) {
        try {
          this.chatHistory = JSON.parse(savedHistory)
          console.log(`加载用户 ${userInfo.userId} 的多角度生成对话历史:`, this.chatHistory.length, '条')
        } catch (e) {
          console.error('解析对话历史失败:', e)
          this.chatHistory = []
        }
      }
    },
    // 保存对话历史
    saveChatHistory() {
      const userInfo = this.$store.state.morejoy_assistant?.userInfo
      if (!userInfo || !userInfo.userId) {
        // 用户未登录，跳过保存
        return
      }
      // 限制最多保存10轮对话（20条消息）
      let historyToSave = [...this.chatHistory]
      if (historyToSave.length > 20) {
        historyToSave = historyToSave.slice(-20)
        this.chatHistory = historyToSave
      }
      const storageKey = `multi_angle_chat_history_${userInfo.userId}`
      localStorage.setItem(storageKey, JSON.stringify(historyToSave))
    },
    // 重新生成
    handleRegenerate(index) {
      // 找到对应的用户消息（AI消息的前一条）
      if (index > 0) {
        const userMessage = this.chatHistory[index - 1]
        if (userMessage && userMessage.role === 'user') {
          // 移除失败的 AI 回复
          this.chatHistory.splice(index, 1)
          this.saveChatHistory()
          // 通过 sessionStorage 传递重新生成的参数给子组件
          const regenerateData = {
            content: userMessage.content,
            images: userMessage.images
          }
          sessionStorage.setItem('multi_angle_regenerate', JSON.stringify(regenerateData))
          // 通知子组件重新生成
          this.$nextTick(() => {
            // 触发子组件的重新生成（通过事件总线或直接调用）
            this.$root.$emit('multi-angle-regenerate', regenerateData)
          })
        }
      }
    },
    // 显示图片预览
    showImagePreview(imageUrl) {
      this.previewImageUrl = imageUrl
      this.imagePreviewVisible = true
    },
    // 关闭图片预览
    closeImagePreview() {
      this.imagePreviewVisible = false
      this.previewImageUrl = ''
    }
  }
}
</script>

<style lang="less" scoped>
@import "@/style/common.less";
@import "@/assets/fonts/style.css";
@import "@/assets/font_sczlgzino/iconfont.css";

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  font-family: "icomoon";
  overflow: hidden;
}

.iconfont {
  font-family: "iconfont" !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 25px;
}

// 页面最外层容器
.multi-angle-generation-container {
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  background: white;
  overflow: hidden;
}

// 顶部 header
header {
  height: 95px;
  width: 100%;
  padding: 10px 30px;
  font-family: "icomoon";
  font-size: 18px;
  border-bottom: 1px solid #e5e7eb;
  background: white;

  .header-content {
    display: flex;
    align-items: center;
    height: 100%;
  }

  .logo-section {
    width: 230px;
    height: 75px;
    display: flex;
    align-items: center;
    padding: 10px;

    img {
      width: 230px;
      object-fit: cover;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        transform: scale(1.05);
      }
    }
  }

  .header-spacer {
    flex: 1;
  }

  .header-actions {
    display: flex;
    gap: 20px;
    align-items: center;

    .home-btn {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 12px 24px;
      border-radius: 10px;
      background-color: #ff8c42;
      color: white;
      cursor: pointer;
      transition: all 0.3s;
      font-size: 16px;
      font-weight: 500;
      white-space: nowrap;

      .iconfont {
        font-size: 20px;
      }

      &:hover {
        background-color: #ff7a2e;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(255, 140, 66, 0.3);
      }
    }

    .header-btn {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 12px 24px;
      border-radius: 10px;
      background-color: rgba(39, 41, 46, 0.05);
      cursor: pointer;
      transition: all 0.3s;
      font-size: 16px;
      color: #333;
      white-space: nowrap;

      .iconfont {
        font-size: 20px;
      }

      &:hover {
        background-color: #f0f0f0;
        transform: translateY(-2px);
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
      }
    }

    .user-avatar {
      display: flex;
      width: 50px;
      height: 50px;
      border: 2px solid #e5e7eb;
      border-radius: 50%;
      overflow: hidden;
      justify-content: center;
      align-items: center;

      img {
        cursor: pointer;
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: all 0.3s;

        &:hover {
          transform: scale(1.1);
        }
      }
    }
  }
}

// 内容区域包裹器
.multi-angle-page-wrapper {
  display: flex;
  width: 100vw;
  height: calc(100vh - 95px);
  overflow: hidden;
}

// 左侧精简导航栏
.slim-sidebar {
  width: 80px;
  height: calc(100vh - 95px);
  background: white;
  border-right: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.05);
  flex-shrink: 0;

  .sidebar-middle {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 30px;
    align-items: center;
    justify-content: center;
  }

  .sidebar-bottom {
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
  }

  .nav-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    padding: 12px 0;
    cursor: pointer;
    transition: all 0.3s;
    border-radius: 8px;
    width: 60px;

    .iconfont {
      font-size: 24px;
      color: #666;
      transition: all 0.3s;
    }

    .nav-icon {
      width: 24px;
      height: 24px;
      color: #666;
      transition: all 0.3s;
    }

    .nav-label {
      font-size: 12px;
      color: #999;
      transition: all 0.3s;
    }

    &:hover {
      background: #f5f7fa;

      .iconfont {
        color: @morejoy;
      }

      .nav-icon {
        color: @morejoy;
      }

      .nav-label {
        color: @morejoy;
      }
    }
  }
}

.right_menu_assistant {
  flex: 1;
  height: calc(100vh - 95px);
  display: flex;
  flex-direction: column;
  background: white;
  overflow: hidden;
  position: relative;
}

// 对话容器
.chat-container {
  flex: 1;
  overflow-y: auto;
  padding: 30px 40px;
  padding-bottom: 250px; // 为底部输入框预留空间
  scrollbar-width: thin;
  scrollbar-color: @basicselect transparent;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: @basicselect;
    border-radius: 3px;

    &:hover {
      background: @morejoy;
    }
  }
}

// 对话历史
.chat-history {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 30px;
}

// 消息项
.message-item {
  display: flex;
  animation: fadeIn 0.3s ease;

  &.user-message {
    justify-content: flex-end;
  }

  &.ai-message {
    justify-content: flex-start;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.message-wrapper {
  display: flex;
  gap: 15px;
  max-width: 75%;
}

.message-avatar {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &.ai-avatar {
    background: linear-gradient(135deg, @morejoy 0%, #ff7a2e 100%);
    display: flex;
    align-items: center;
    justify-content: center;

    .iconfont {
      font-size: 24px;
      color: white;
    }
  }
}

.message-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

// 缩略图容器
.message-thumbnails {
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-right: 12px;
  flex-shrink: 0;
  align-items: flex-start;

  .image-thumbnail {
    width: 60px;
    height: 60px;
    border-radius: 8px;
    background: linear-gradient(135deg, @morejoy 0%, #ff7a2e 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid rgba(255, 255, 255, 0.8);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    overflow: hidden;

    .thumbnail-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}

// 结果图片展示
.message-images {
  display: flex;
  flex-wrap: nowrap;
  gap: 15px;
  margin-top: 10px;

  .result-image-item {
    width: 200px;
    height: 200px;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    transition: all 0.3s;
    flex-shrink: 0;

    &:hover {
      transform: scale(1.02);
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    }

    .result-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  // 占位框样式
  .placeholder-item {
    background: linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: default;

    &:hover {
      transform: none;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    }

    .placeholder-content {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;

      .placeholder-icon {
        font-family: "iconfont" !important;
        font-size: 48px;
        color: #c0c0c0;
        animation: pulse 2s ease-in-out infinite;
      }
    }
  }
}

@keyframes pulse {
  0%, 100% {
    opacity: 0.4;
  }
  50% {
    opacity: 0.8;
  }
}

.user-message .message-text {
  background: @morejoy;
  color: white;
  padding: 15px 20px;
  border-radius: 18px 18px 4px 18px;
  font-size: 16px;
  line-height: 1.6;
  word-wrap: break-word;
}

.ai-message .message-text {
  background: white;
  color: #333;
  padding: 15px 20px;
  border-radius: 18px 18px 18px 4px;
  font-size: 16px;
  line-height: 1.6;
  word-wrap: break-word;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  // 失败气泡的特殊样式
  &.error {
    background: rgba(245, 108, 108, 0.1); // 淡红色背景
    border: 2px solid rgba(245, 108, 108, 0.5); // 红色边框
    color: rgb(245, 108, 108); // 红色文字
  }
}

// 消息按钮组（重新生成按钮）
.message-actions {
  display: flex;
  gap: 10px;
  margin-top: 12px;
  width: 100%;
  flex-basis: 100%; // 强制换行

  .action-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 16px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    background: white;
    color: #666;
    cursor: pointer;
    transition: all 0.3s;
    font-size: 14px;

    &:hover {
      background: #fff8f3;
      color: @morejoy;
      border-color: @morejoy;
    }

    &.regenerate-btn {
      &:hover {
        background: @morejoy;
        color: white;
        border-color: @morejoy;
      }
    }
  }
}

// 空状态
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #999;

  .empty-icon {
    font-size: 80px;
    margin-bottom: 20px;
    opacity: 0.5;
  }

  h3 {
    font-size: 24px;
    font-weight: 600;
    color: #666;
    margin: 0 0 10px 0;
  }

  p {
    font-size: 16px;
    color: #999;
    margin: 0;
  }
}

// AI 输入提示
.typing-indicator {
  display: flex;
  flex-direction: column;
  gap: 15px;
  max-width: 1200px;
  margin: 0 auto;
  margin-top: 30px; // 增加与用户消息的距离
  animation: fadeIn 0.3s ease;

  .typing-wrapper {
    display: flex;
    gap: 15px;
    align-items: center;
  }

  .typing-avatar {
    width: 45px;
    height: 45px;
    border-radius: 50%;
    background: linear-gradient(135deg, @morejoy 0%, #ff7a2e 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    .iconfont {
      font-size: 24px;
      color: white;
    }
  }

  .typing-content {
    display: flex;
    flex-direction: column;
    gap: 6px;

    .typing-dots {
      display: flex;
      gap: 6px;
      padding: 15px 20px;
      background: white;
      border-radius: 18px 18px 18px 4px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

      span {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: @morejoy;
        animation: typing 1.4s infinite;

        &:nth-child(2) {
          animation-delay: 0.2s;
        }

        &:nth-child(3) {
          animation-delay: 0.4s;
        }
      }
    }

    .node-executing {
      padding: 15px 25px;
      background: white;
      border-radius: 18px 18px 18px 4px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
      .node-name {
        font-size: 13px;
        color: #999;
        font-weight: 400;
        animation: breathe 2s ease-in-out infinite;
        display: inline-block;
      }
    }
  }

  // 生成中预留框容器
  .generating-placeholder-container {
    display: flex;
    flex-wrap: nowrap;
    gap: 15px;
    margin-left: 60px; // 与上方头像和状态栏对齐

    .generating-placeholder-item {
      width: 200px;
      height: 200px;
      border-radius: 12px;
      overflow: hidden;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
      flex-shrink: 0;
      background: linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 100%);

      .placeholder-animation {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        video {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 12px;
        }
      }
    }
  }
}

@keyframes typing {
  0%, 60%, 100% {
    opacity: 0.3;
    transform: translateY(0);
  }
  30% {
    opacity: 1;
    transform: translateY(-10px);
  }
}

@keyframes breathe {
  0%, 100% {
    opacity: 0.6;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.05);
  }
}

// 图片预览弹窗
.image-preview-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(128, 128, 128, 0.5); // 灰色半透明背景
  backdrop-filter: blur(20px); // 毛玻璃效果
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: fadeIn 0.3s ease;

  .image-preview-content {
    position: relative;
    max-width: 90vw;
    max-height: 90vh;
    display: flex;
    align-items: center;
    justify-content: center;

    .preview-image {
      max-width: 100%;
      max-height: 90vh;
      object-fit: contain;
      border-radius: 12px;
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
      animation: zoomIn 0.3s ease;
    }

    .close-btn {
      position: absolute;
      top: -50px;
      right: -50px;
      width: 40px;
      height: 40px;
      background: rgba(255, 255, 255, 0.9);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 32px;
      color: #666;
      cursor: pointer;
      transition: all 0.3s;
      line-height: 40px;
      text-align: center;

      &:hover {
        background: white;
        color: @morejoy;
        transform: scale(1.1);
      }
    }
  }
}

@keyframes zoomIn {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
